import "./Trust.css";

function Trust() {
  return (
    <section className="trust">
      <div className="container trust-wrap">

        <p className="trust-label">TRUSTED IMPACT</p>

        <h2 className="trust-title">
          Supporting organizations across industries to drive
          meaningful and lasting transformation.
        </h2>

        <div className="trust-stats">

          <div className="trust-item">
            <h3>10+</h3>
            <p>Industries</p>
          </div>

          <div className="trust-item">
            <h3>50+</h3>
            <p>Engagements</p>
          </div>

          <div className="trust-item">
            <h3>100%</h3>
            <p>Client Focus</p>
          </div>

        </div>

      </div>
    </section>
  );
}

export default Trust;